import { Pipe, PipeTransform } from '@angular/core';
import { ScriptMode } from './enums';

@Pipe({
    name: 'filterByScriptmode',
    pure: false,
    standalone: false
})
export class FilterByScriptModePipe implements PipeTransform {
    transform(items: any[], scriptMode: ScriptMode): any {
        if (!items || !scriptMode ) {
            return items;
        }
        return items.filter((item) => {
            if(!item?.filter?.length) {
                return true;
            }
            return item.filter.includes(scriptMode);
        })
    }
}
